import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import TalkGateway from '../main/talkGateway';
import GentleAppState from '../common/appstate';
import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse(process.env.ENC_KEY); // 32 byte key

const _domainId = 'NODE0000000001'
const _serviceType = 'SVTLK';
let _gatewayCustomerId = '';
let _categoryId = '';
let _customerId = 'test1';

let _talkId = '';
let _lastSeq = 0; // 마지막 seq

let component;

var GentleServiceConsulting = Object.create(GentleWidget, {
    sponserId: {
        writable: true,
        configurable: false,
        enumerable: true
    },
    sponserName: {
        writable: true,
        configurable: false,
        enumerable: true
    }
})

const err_code = {
    NOT_OPERATION: 1001,
    DELAY_CONSULTING: 1002,
    ALREADY_ON_CONSULTING: 1003,
    UNAVAILABLE_CONSULTING: 1004,
    NO_ERROR: 0,
};

const errorMessage = function (code, errorCode) {
    const html = `관리자에게 문의하세요. code : ${code}, ${errorCode} `
    var bubble = Object.create(GentleComponentBubble);
    bubble.createComponent({
        html,
    });
    bubble.insert();
}

GentleServiceConsulting.CommonInsertSurvey = function (param) {
    console.log('CommonInsertSurvey', param);

    const {
        feedback
    } = param;

    // alert(feedback); return;

    const onSuccess = function (result) {
        console.log('CommonInsertSurvey.onSuccess', result);

        const {
            errorCode
        } = JSON.parse(result);

        if (errorCode != err_code.NO_ERROR) {
            console.log('error');
            errorMessage('GentleServiceConsulting.CommonInsertSurvey')
            return;
        }

        // todo : 등록완료
        {
            var bubble = Object.create(GentleComponentBubble);
            bubble.createComponent({
                html: '감사합니다.',
            });
            bubble.insert();
        }
    };

    const onFailed = function (data) {
        console.log('onFailed', data);
    }

    /**
    "{
        command:CommonInsertSurvey,
        surveyType:CUSAF,
        domainId:NODE0000000001,
        serviceType:SVTLK,
        targetId:TCKT0000000030

        feedback		N		int	만족도 점수
        customerEmail		N		string	고객 이메일
        customerName		N		string	고객 이름
        customerTel		N		string	고객 연락처
        customerNo		N		string	고객 식별번호
        customerNickname		N		string	고객 닉네임
        option01 ~ 50		N		string	옵션정보 01 ~ 50        
    }"			
     */

    const cmd = {
        command: 'CommonInsertSurvey',
        surveyType: 'CUSAF',
        domainId: _domainId,
        serviceType: _serviceType,
        targetId: _talkId,
        feedback, // -1, 20, 40, 60, 80, 100
    }

    enomix_request(cmd, onSuccess, onFailed);
}

GentleServiceConsulting.TalkEnd = function (restart = false) {
    console.log('TalkEnd');

    window.chatbotTalkAvailable = false;
    _categoryId = '';

    const onSuccess = function (result) {
        console.log('TalkEnd.onSuccess', result);
        window.chatbotConsulting = false;
        window.chatbotConsultingConnected = false;

        const {
            errorCode,
            data
        } = JSON.parse(result);
        // console.log('TalkStart.onSuccess.data', data);
        const {
            messages
        } = data;
        // console.log('messages', messages);

        if (errorCode != err_code.NO_ERROR) {
            console.log('error');
            errorMessage('GentleServiceConsulting.TalkEnd')
            return;
        }

        messages.forEach(element => {
            GentleServiceConsulting.insertMsg(element);
        });

        if (restart) {
            TalkStart({});
        }

        GentleServiceConsulting.insertReview();
    };

    const onFailed = function (data) {
        console.log('onFailed', data);
        // todo 
    }

    const cmd = {
        command: 'TalkEnd',
        domainId: _domainId,
        serviceType: _serviceType,
        customerId: _customerId,
        talkId: _talkId,
        seq: _lastSeq,
    }

    enomix_request(cmd, onSuccess, onFailed);
}

GentleServiceConsulting.insertMsg = function (element) {
    const component =  Object.create(this);

    const {
        msg,
        seq
    } = element;
    // console.log('msg', seq, msg,);

    if (seq > _lastSeq) {
        _lastSeq = seq;
        console.log('_seq>', _lastSeq);

        const {type, msg, ext} = element;
        console.log('type, msg, ext', type, msg, ext);

        if(type === 'URL'){
            if(
                ext.toUpperCase() == '.JPG' |
                ext.toUpperCase() == '.JPEG' |
                ext.toUpperCase() == '.PNG' |
                ext.toUpperCase() == '.BMP' |
                ext.toUpperCase() == '.GIF' 
            ){
                console.log('this is image');
                // todo : image view
                const html = `
                <div class="card-view">
                    <a href="${msg}" target="_blank"><img src="${msg}" ></a>
                </div>`;

                let $container = $(html)
                component.setPrefix("login");
                component.init($container);
                component.insert();
            }else // file
            {
                {
                    var bubble = Object.create(GentleComponentBubble);
                    bubble.createComponent({
                        html: '파일을 보냈습니다.',
                    });
                    bubble.insert();
        
                }
                {
                    const option = [
                        {
                            isHidden: true,
                            text: '다운로드 받기',
                            onClick: function(){
                                window.open(msg, '_blank');
                            },
                        },
                    ]
                    var button = Object.create( GentleComponentButton);
                    button.createComponent(option);
                    button.insert();
                }
            }
        }else // 메시지
        {
            var bubble = Object.create(GentleComponentBubble);
            bubble.createComponent({
                html: msg,
            });
            bubble.insert();
        }


        GentleUtil.timeStamp()
    }
}

GentleServiceConsulting.insertReview = function () {
    const component = Object.create(this);

    console.log('insertReview');
    // todo : 만족도 조사
    let html; {
        // var bubble = Object.create(GentleComponentBubble);
        // bubble.createComponent({
        //     html: `             고객님, 만족스러운 상담이 되셨나요? 추가 문의가 있으시면 언제든 톡으로 문의해 주세요. ^^ 톡 상담을 이용해 주셔서 감사합니다!                              `

        // });
        // bubble.insert()

        html =
            `<div class="card-view-star">
            <label for="rate1">
                <span name="picture1" class="fit-picture" alt="">
            </label>
            <label for="rate2">
                <span name="picture2" class="fit-picture" alt="">
            </label>
            <label for="rate3">
                <span name="picture3" class="fit-picture" alt="">
            </label>
            <label for="rate4">
                <span name="picture4" class="fit-picture" alt="">
            </label>
            <label for="rate5">
                <span name="picture5" class="fit-picture" alt="">
            </label>
        </div>
        `

        let $container = $(html);
        component.setPrefix("consult");
        component.init($container);
        component.insert();

        //bind
        // const cssStar = function(){
        const $starList1 = component.find('[name="picture1"]');
        const $starList2 = component.find('[name="picture2"]');
        const $starList3 = component.find('[name="picture3"]');
        const $starList4 = component.find('[name="picture4"]');
        const $starList5 = component.find('[name="picture5"]');

        const arrStar = [$starList1, $starList2, $starList3, $starList4, $starList5];

        //모든별의 불을 끔
        const offStar = function () {
            for(let i = 0; i< 5; i++){
                arrStar[i].attr("class", "fit-picture");
            }
        }

        //별을 순회하며 불을 넣어줌
        const rotateStar = function(idx){
            for(let i = 0; i< idx; i++){
                arrStar[i].attr("class", function (index, attr) {
                    return attr == "fit-picture-on" ? "fit-picture" : "fit-picture-on";
                });
            }
        }

        $starList1.on('click', function () {
            offStar();
            rotateStar(1);
        })
        $starList2.on('click', function () {
            offStar();
            rotateStar(2);
        })
        $starList3.on('click', function () {
            offStar();
            rotateStar(3);
        })
        $starList4.on('click', function () {
            offStar();
            rotateStar(4);
        })
        $starList5.on('click', function () {
            offStar();
            rotateStar(5);
        })
        

        //제출 버튼
        {
            const buttons = [{
                    title: "별점 제출",
                    onClick: function () {
                        var clickVal;

                        if ($starList5.attr("class") == "fit-picture-on") {
                            clickVal = "100"
                        } else if ($starList4.attr("class") == "fit-picture-on") {
                            clickVal = "80"
                        } else if ($starList3.attr("class") == "fit-picture-on") {
                            clickVal = "60"
                        } else if ($starList2.attr("class") == "fit-picture-on") {
                            clickVal = "40"
                        } else if ($starList1.attr("class") == "fit-picture-on") {
                            clickVal = "20"
                        }
                        // console.log("clickVal===", clickVal)
                        GentleServiceConsulting.CommonInsertSurvey({feedback: clickVal});

                    }
                }

            ];

            var quickReply = Object.create(GentleComponentQuickReply);
            quickReply.createComponent(buttons);
            quickReply.insert();

        }
        GentleUtil.timeStamp();

    }
}

const TalkReceive = function (callback) {
    console.log('TalkReceive');
    // const {seq, talkId} = param;
    const onSuccess = function (result) {
        console.log('TalkReceive.onSuccess', result);

        const {
            errorCode,
            data
        } = JSON.parse(result);
        console.log('TalkReceive.onSuccess.data', data);

        if (errorCode != err_code.NO_ERROR) {
            // todo : 에러
            if(window.chatbotConsulting){
                console.log('error');
                // errorMessage('GentleServiceConsulting.TalkReceive')
            }
            else{
                // ignore
            }

            return;
        }

        {
            const {
                messages
            } = data;
            // console.log('messages', messages);

            messages.forEach(element => {
                console.log('msg', element);
                GentleServiceConsulting.insertMsg(element);
            });

            if (callback) {
                callback();
            }
        }
    };

    const onFailed = function (data) {
        console.log('TalkReceive.onFailed', data);
        // todo 
    }

    const cmd = {
        command: 'TalkReceive',
        domainId: _domainId,
        serviceType: _serviceType,
        customerId: _customerId, // _gatewayCustomerId, // _customerId,
        talkId: _talkId,
        seq: _lastSeq,
    }

    enomix_request(cmd, onSuccess, onFailed);
}

// 메시지를 보낸다.
GentleServiceConsulting.TalkSend = function (param) {
    const {
        message,
        talkId,
        seq,
        customerId,
        imageData
    } = param;
    const onSuccess = function (result) {
        console.log('TalkSend.onSuccess', result);

        const {
            errorCode,
            data
        } = JSON.parse(result);
        // console.log('TalkStart.onSuccess.data', data);

        if (errorCode != err_code.NO_ERROR) {
            // todo : 에러
            console.log('error');
            errorMessage('GentleServiceConsulting.TalkSend')
            return;
        }

        console.log('TalkSend.data', data);

        const {
            messages
        } = data;
        const m = messages[0];
        const {
            seq
        } = m;

        _lastSeq = seq;
        // console.log('send: _seq>', _seq);
    };

    const onFailed = function (data) {
        console.log('onFailed', data);
        // todo 
    }

    const cmd = {
        command: 'TalkSend',
        domainId: _domainId,
        serviceType: _serviceType,
        customerId: _customerId,
        talkId: _talkId,
        seq: _lastSeq,
        message,
    }
    
    if(imageData) {
        cmd.domainId = _categoryId;
        enomix_img_request(imageData, cmd, onSuccess, onFailed);
    }else {
        enomix_request(cmd, onSuccess, onFailed);
    }
}

window.TalkSend = function (message, imageData) {
    console.log('window.TalkSend');
    if(!window.chatbotTalkAvailable) return;
    let param = {};
    if(imageData) {
        param = {
            message, imageData
        };
    } else {
        param = {
            message
        };
    }
    GentleServiceConsulting.TalkSend(param)
}

const onConnectionEstablished = function () {
    console.log('onConnectionEstablished');
    // EX) parent.setIsGatewayAlive(true);
    // Gateway 서버와 연결이 되었을 경우 호출.
    //  - 서버연결 flag 값 true로 변경.
    //  - 신규 메시지 발생 시 이벤트 수신 가능
    //  - 메시지 수신 함수 호출.

    window.chatbotConsulting = true;
    console.log('GentleAppState.setConsultingButton()');
    GentleAppState.setConsultingButton();

    TalkReceive();
}

const onConnectionBroken = function (param) {
    console.log('onConnectionBroken', param);

    // EX) parent.setIsGatewayAlive(false);

    // Gateway 서버와 연결이 해제 되었을 경우 호출
    //  - 서버연결 flag 값 false로 변경.
    //  - Polling(주기적으로 서버요청) 방식으로 변경하여 메시지 수신    
}

const onNewMessage = function (talkId) {
    console.log('onNewMessage', talkId);

    if (!window.chatbotConsultingConnected) // 상담원과의 연결여부
    {
        console.log('상담원 연결됨');
        window.chatbotConsultingConnected = true;
    }

    _talkId = talkId;

    // store.dispatch('RECEIVE_CHAT_FROM_COUNSELOR', { talkId });
    // todo : 메시지를 가져오는 플로우로
    const param = {
        talkId: _talkId,
    }
    TalkReceive();
}

const onInputStatus = function (param) {
    console.log('onInputStatus', param);

    // 정확히 안넘어온다. 
    // 메시지가 도달하고 넘어오기도 한다. 싱크를 맞추기 힘듬


    // window.ChatConsole.loadingBox(loading);
    // loading = !loading;

    // setTimeout(function(){
    //     window.ChatConsole.loadingBox(false);
    // }, 1000)
}

const onTicketEnded = function (param) {
    console.log('onTicketEnded', param);
    window.chatbotTalkAvailable = false;
    if(window.chatbotConsulting == false) return;

    // 메시지를 다 받아온다.
    // const isExit = true;
    TalkReceive(() => GentleServiceConsulting.insertReview())

    console.log('temp')

    window.chatbotConsulting = false;
    window.chatbotConsultingConnected = false;
    GentleAppState.setLoginButton();
}

const onTicketForwardComplete = function (param) {
    console.log('onTicketForwardComplete', param);
}

const TalkStart = function (param) {
    console.log('TalkStart>', param)

    if(window.chatbotConsultingConnected){
        console.log('이미 상담중입니다.');
        return;
    } 

    const {
        customerId,
        nodeId,
        message,
        option49,
        chatBotHistory
    } = param;
    const onSuccess = function (result) {
        console.log('TalkStart.onSuccess', result);

        const {
            errorCode,
            data
        } = JSON.parse(result);
        // console.log('TalkStart.onSuccess.data', data);

        if (errorCode != err_code.NO_ERROR) {
            console.log('error');

            if(err_code !== '') // 빈값을 보내는 경우는 제외한다. 성공간주
            {
                errorMessage('TalkStart.errorCode', errorCode);
                return;
            }

            {
                var bubble = Object.create(GentleComponentBubble);
                bubble.createComponent({
                    html:'에러코드 비어있슴',
                });
                bubble.insert();
            }
        }

        console.log('TalkStart.data', data);

        // if()

        /*
        useCall		boolean	전화예약 사용여부	톡 상담접수 불가 시, 전화예약 사용여부
        welcomeMessage		string	상담연결 인사 메세지	톡 상담 이용안내 템플릿 메세지
        isReceiptOutoftime		boolean	상담운영시간 외 접수 여부	상담운영시간 외 접수 여부
        gatewayCustomerId		string	게이트웨이 고객 아이디	게이트웨이 고객 아이디, 게이트웨이 연결 시 사용
        logClientId		string	톡 상담 요청 로그용 아이디	상담 요청 로그용 아이디
        tempCustomerId		string	비회원 고객아이디	비회원 고객 아이디, 비회원 상담신청 시 리턴
        talkId		string	톡 아이디	톡 아이디
        gatewayTalkId		string	게이트웨이 톡 아이디	게이트웨이 톡 아이디, 게이트웨이 이벤트 수신 체크 시 사용        
        */
        const {
            gatewayCustomerId,
            talkId,
            welcomeMessage
        } = data;

        _gatewayCustomerId = gatewayCustomerId; // 비회원인 경우

        _customerId = _customerId ? _customerId : _gatewayCustomerId;
        _talkId = talkId;

        // if (!context.state.loadedEnomix) //gateway 로딩 안된 경우
        // if(!window.Gateway)
        {
            // enomixHandlers.loadEnomix(talkStartResult.data.customerId);

            if (!window.Gateway) {
                console.log('return : !window.Gateway')
                return;
            }

            $.talkGateway = new TalkGateway();
            $.gateway = new window.Gateway();

            // $.gateway.addListener($.gateway.EVENT.NEW_MESSAGE, $.talkGateway._newMessage);
            // $.gateway.addListener($.gateway.EVENT.INPUT_STATUS, $.talkGateway._inputStatus);
            // $.gateway.addListener($.gateway.EVENT.TICKET_ENDED, $.talkGateway._ticketEnded);
            // $.gateway.addListener($.gateway.EVENT.CONNECTION_ESTABLISHED, $.talkGateway._connectionEstablished);
            // $.gateway.addListener($.gateway.EVENT.FORWARD_COMPLETE, $.talkGateway._ticketForwardComplete);
            // $.gateway.addListener($.gateway.EVENT.CONNECTION_BROKEN, $.talkGateway._connectionBroken);
            $.gateway.addListener($.gateway.EVENT.CONNECTION_ESTABLISHED, onConnectionEstablished);
            $.gateway.addListener($.gateway.EVENT.NEW_MESSAGE, onNewMessage);
            $.gateway.addListener($.gateway.EVENT.INPUT_STATUS, onInputStatus);
            $.gateway.addListener($.gateway.EVENT.TICKET_ENDED, onTicketEnded);
            $.gateway.addListener($.gateway.EVENT.FORWARD_COMPLETE, onTicketForwardComplete);
            $.gateway.addListener($.gateway.EVENT.CONNECTION_BROKEN, onConnectionBroken);

            $.talkGateway._getConfig({
                _domainId: 'NODE0000000001',
                _serviceType: 'SVTLK',
                _customerId: _gatewayCustomerId,
            });
        }

        {
            // var bubble = Object.create( GentleComponentBubble );   
            // bubble.createComponent({
            //     html: welcomeMessage,
            // });
            // bubble.insert();
            // GentleUtil.timeStamp();
        }

        // todo : 이건 용도가 뭐야? 
        // context.commit('UPDATE_TALK_ID', talkStartResult.data.talkId); // id 업데이트

        // todo : context.commit('UPDATE_ENOMIX'); // 플래그 켜기

        // ui
        {
            // context.commit('HIDE_LOADING');
            // 메시지전달 : context.commit('ADD_CONVERSATION', chatbotChatHandler(message));
            // 상담모드로 전환 // context.commit('UPDATE_MODE', dictionary.writerType.COUNSELOR);
            // context.commit('TOGGLE_TOAST_VISIBLE');        
        }
    };

    const onFailed = function (data) {
        console.log('onFailed', data);
        // todo 
        errorMessage('Talk Start');
    }

    _customerId = GentleAppState.isLogin ? GentleAppState.custNo : '';

    /**
     * "* Web AI URL 을 사용하지 않고 챗봇화면을 통해 상담으로 들어오는 경우 반드시 필요하다. 
        * List 형식으로 들어오며 여러 개의 메세지 데이터들로 이루어져 있으며 반드시 양식에 맞추어진 데이터들이 필요하다.
            - 하나의 메세지 데이터
            {
                messageSeq : 메세지 번호,
                senderFlag : 사용자에 대한 식별자 (C : 고객, B : 챗봇),
                message : 메세지 내용,
                botCreatedDate : 메세지 생성 날짜 (YYYYMMDDHHMMSS)
            }
        "
     */
    /**
     * "상담 인입 채널 정보
    CHNL0000000001 : PC웹
    CHNL0000000002 : 모바일웹
    CHNL0000000003 : 모바일앱
    CHNL0000000023 : PC웹 AI
    CHNL0000000024 : 모바일 웹 AI"
     */
    // console.log('GentleAppState>', GentleAppState)
    const inChannelId = GentleAppState.isPc ? 'CHNL0000000001' : 'CHNL0000000002'; // 
    _categoryId = nodeId;
    
    const cmd = {
        command: 'TalkStart',
        domainId: _domainId,
        serviceType: _serviceType,
        inChannelId,
        customerId: _customerId,
        nodeId,
        message,
        option49,
        chatBotHistory
    }
    enomix_request(cmd, onSuccess, onFailed);
}

GentleServiceConsulting.CommonNode = function (nodeId) {
    const onSuccess = function (result) {

        const {
            errorCode,
            data
        } = JSON.parse(result);

        if (errorCode === 0) {
            errorMessage('GentleServiceConsulting.CommonNode')
            return;
        }
    };

    const onFailed = function (data) {
        console.log('onFailed');
        // todo 
    }

    const parentId = 'NODE0000000001'

    {
        const proxy = Object.create(GentleProxy);
        const param = {
            command: 'CommonNode',
            domainId: _domainId,
            nodeId
        }

        proxy.request("enomix", param, onSuccess, onFailed);
    }
}

const CommonNodeList = function () {
    console.log('CommonNodeList');
    const onSuccess = function (result) {
        console.log("CommonNodeList success")
        console.log('CommonNodeList.result', JSON.parse(result));

        const {
            errorCode,
            data
        } = JSON.parse(result);
        console.log("result.errorCode", result.errorCode)
        console.log("data", data)
        if (errorCode != err_code.NO_ERROR) {
            errorMessage('GentleServiceConsulting.CommonNodeList')
            console.log('error');
            return;
        }

        let chatBotHistory = [];
        _lastSeq = 0;
        console.log('window.chatbotHistory', window.chatbotHistory);
        window.chatbotHistory.forEach(element => {
            _lastSeq++;
            const {
                message,
                botCreatedDate,
                senderFlag
            } = element;

            chatBotHistory.push({
                messageSeq: `${_lastSeq}`, // 문자로
                // senderFlag: 'C', 'B' 챗봇 // todo: 
                senderFlag,
                message,
                botCreatedDate,
            });
        });
        // console.log('_lastSeq', _lastSeq);
        window.chatbotHistory = [];

        console.log('CommonNodeList.data>', data);
        const {
            nodeList
        } = data;
        nodeList.forEach(node => {
            console.log('node>', node);

            const text = node.nodeName;
            const prev = ''; // todo : 이전 상담내용
            const message = node.nodeName;


            const option = [{
                isSecondary: true,
                isCardWidth: true,
                send: false,
                isHidden: true,
                text,
                user: 'user',
                onClick: function () {
                    console.log('nodeName', node.nodeName);
                    console.log('window.chatbotTalkAvailable>', window.chatbotTalkAvailable);
                    if(!window.chatbotTalkAvailable){
                        return;
                    }

                    if(window.chatbotConsultingConnected){
                        var bubble = Object.create(GentleComponentBubble);
                        bubble.createComponent({
                            html: '상담원과 연결된 상태입니다.',
                        });
                        bubble.insert();
                        return;
                    } 

                    const param = {
                        nodeId: node.nodeId,
                        text, // 
                        prev, // 이전 대화 이력
                        message,
                        chatBotHistory,
                    };
                    console.log("nodelist onclick param", param)
                    // enomixHandlers.startTalk(category.data.nodeId, data.text, data.previousConversation);

                    TalkStart(param);
                },
            }, ]
            var button = Object.create(GentleComponentButton);
            button.createComponent(option);
            button.insert();
        });
        GentleUtil.timeStamp();
    };

    const onFailed = function (data) {
        console.log('onFailed');
        // todo 
    }

    const parentId = 'NODE0000000001'

    const cmd = {
        command: "CommonNodeList",
        domainId: _domainId,
        serviceType: _serviceType,
        parentId
    }

    enomix_request(cmd, onSuccess, onFailed);
}

GentleServiceConsulting.TalkAvailable = function () {
    console.log('TalkAvailable');

    window.chatbotConsultingConnected = false;

    const onSuccess = function (result) {
        console.log('onSuccess>', result);
        // console.log('onSuccess.data>', result.data);

        // const parsed = typeof(result) === 'string' ? JSON.parse(result) : result;
        const parsed = JSON.parse(result) 
        const {
            errorCode
        } = parsed;
        // console.log('errorCode>', errorCode);
        const isNotWorkingHour = parsed.errorCode === err_code.NOT_OPERATION;
        const isDelayConsulting = parsed.errorCode === err_code.DELAY_CONSULTING;
        const isUnavailableConsulting = parsed.errorCode === err_code.UNAVAILABLE_CONSULTING;
        const isAlreadyOnConsulting = parsed.errorCode === err_code.ALREADY_ON_CONSULTING;
        const isAbnormalError = (
            parsed.errorCode !== err_code.NO_ERROR &&
            !isNotWorkingHour &&
            !isDelayConsulting &&
            !isAlreadyOnConsulting &&
            !isUnavailableConsulting
        );

        if (isAlreadyOnConsulting) {
            console.log('이미 상담중')
            return;
            // todo : 기존 상담내역 가져오기
        }

        if (isAbnormalError) // 비정상 에러
        {
            console.log('isAbnormalError')
            errorMessage('GentleServiceConsulting.TalkAvailable')

            return;
        }

        if (isNotWorkingHour || isDelayConsulting || isUnavailableConsulting) {
            // todo

            //   const result2 = createFailMessage({
            //     lang: options.lang,
            //     message: parsed.data.templateMessage,
            //     errorCode: err_code.NO_ERROR,
            //     isDelayConsulting,
            //     isNotWorkingHour,
            //     type: parsed.errorCode,
            //     chnlCd: options.chnlCd,
            //   });

            //   return result2;
            console.log('errorMessage', errorMessage);
            const {
                templateMessage
            } = JSON.parse(result).data;

            switch (errorCode) {
                case 1001: // 운영시간이 아님
                    // todo : 
                    break;
                case 1002: // 최대 대기 상담 수 초과						
                    // todo : 
                    break;
                case 1003: // 고객 개인 별 최대 동시 상담 수 초과						
                    // todo : 
                    break;
            }

            {
                var bubble = Object.create(GentleComponentBubble);
                bubble.createComponent({
                    html: templateMessage,
                });
                bubble.insert();
                GentleUtil.timeStamp();
            }

            return;
        }

        if (isAlreadyOnConsulting) // 이미 상담중...
        {
            // const resultOfRepeat = await repeatExitAndTalkAvailable(options, parsed);
            // return resultOfRepeat;

            GentleServiceConsulting.TalkEnd(param, true) // 끊고 다시 요청
            // todo 

            return;
        }

        //   return {
        //     errorCode: dictionary.enomixErrorType.NO_ERROR,
        //     isAvailable: true,
        //     message: parsed.data.welcomeMessage,
        //   };

        const {
            welcomeMessage
        } = parsed.data;
        console.log('welcomeMessage', welcomeMessage);

        window.chatbotTalkAvailable = true; 
        console.log('window.chatbotTalkAvailable = true');
        {
            // TalkAvailable의 결과가 
            if (isDelayConsulting) // 지연중...
            {
                // 로딩 숨기고 // context.commit('HIDE_LOADING');

                const {
                    disableContentMessage
                } = parsed.data;
                if (context.state.delayConsultingCount < MAX_REPEAT_CALL_ERROR) {
                    // context.commit('ADD_CONVERSATION', chatbotChatHandler(disableContentMessage));
                    // 딜레이 카운트 ++ // context.commit('ADD_DELAY_CONSULTING_COUNT');
                    // todo : 메시지 출력
                    console.log('disableContentMessage', disableContentMessage);
                } else {
                    // 이건 api 문서에 없는건데...

                    // const result = await enomixHandlers.getErrorTemplate();
                    // if (!result) {
                    //     return;
                    // }
                    // context.commit('ADD_CONVERSATION', chatbotChatHandler(result.data.disableContentMessage));
                    return;
                }

                // 일정 시간후에 상담하기 플로우를 탄다.
                {
                    const minute = 6 * 10 * 1000; // 1분후에...

                    // todo : 타이머 실행하기

                    // const callConnectionOfConsulting = () => {
                    //     context.dispatch('HANDLE_CONSULTING', data);
                    // };        
                    // setTimeout(callConnectionOfConsulting, minute);
                }
                return;
            }


            // todo : 상담가능여부 체크. 신세계랑 다르다... 
            // if (isAvailable) // 상담가능
            {
                // 카테고리 가져오기 
                // const category = await enomixHandlers.getCategory();
                // if (!category) {
                //     return;
                // }

                {   
                    var bubble = Object.create(GentleComponentBubble);
                    bubble.createComponent({
                        html: welcomeMessage,
                    });
                    bubble.insert();
                }

                CommonNodeList();
                return;
            }
        }
    };

    const onFailed = function (data) {
        console.log('onFailed', data);
        // todo 
    }
    // ui를 상담모드로 셋팅

    // 가능여부 체크
    // TalkAvailable
    {
        /**
        CHNL0000000001 : PC웹
        CHNL0000000002 : 모바일웹
        CHNL0000000003 : 모바일앱
        CHNL0000000023 : PC웹 AI
        CHNL0000000024 : 모바일 웹 AI"
        */
        const inChannelId = 'CHNL0000000001'; // todo 
        const customerId = 'guest' + Math.random().toString(36).substr(2, 11); // 'guest'; // todo
        _customerId = customerId;
        console.log('customerId>', customerId);

        const cmd = {
            command: "TalkAvailable",
            domainId: _domainId,
            subcommands: "isBlockStatus,isWorkTime,isUpToWaitingCustomer",
            // subcommands: "isUpToActiveCustomer,isBlockStatus,isWorkTime,isUpToWaitingCustomer,isValidUser",
            serviceType: _serviceType,
            inChannelId,
            // customerId, // : _customerId
        };

        enomix_request(cmd, onSuccess, onFailed);
    }
}

const customerIdEncrypt = (text) => {
    const iv = CryptoJS.lib.WordArray.random(16); // 16 byte IV
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64); // IV와 암호문 결합하여 전송
};

const enomix_request = function (cmd, onSuccess, onFailed) {
    const proxy = Object.create(GentleProxy);
    if(cmd.customerId){
        cmd.customerId = customerIdEncrypt(cmd.customerId);
    };
    console.log('enomix_request', cmd);
    
    const json = encodeURIComponent(JSON.stringify(cmd));
    console.log('json', json);

    const param = `cmd=${json}`;
    // const param = {
    //     cmd: json
    // }
    // console.log("12312312312312312312312312")
    console.log("param", param)
    proxy.request("enomix", param, onSuccess, onFailed);
}

const enomix_img_request = function (imageData, cmd, onSuccess, onFailed) {
    const proxy = Object.create(GentleProxy);
    if(cmd.customerId){
        cmd.customerId = customerIdEncrypt(cmd.customerId);
    };
    console.log('enomix_img_request', imageData, cmd);

    const json = encodeURIComponent(JSON.stringify(cmd));

    const formData = new FormData();
    formData.append('file', imageData);
    formData.append('cmd', json);

    proxy.requestFormData("enomix-upload", formData, onSuccess, onFailed);
}

export default GentleServiceConsulting;